exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host .menuButtons {\n  position: absolute;\n  bottom: 20px;\n  right: 20px; }\n\n:host .canvas {\n  padding: 0px;\n  margin: 5px;\n  border: 0px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/features/components/feature-diagram/feature-diagram.component.scss
// module id = ../../../../../src/app/modules/features/components/feature-diagram/feature-diagram.component.scss
// module chunks = main